import React, { useCallback, useEffect } from "react";
import CompartilhamentoCalculadoraDialog from "./CompartilhamentoCalculadoraDialog";
import { useDispatch, useSelector } from "react-redux";
import { getDialogCompartilhamento } from "../../selectors/usuario.selectors";
import { actions } from "../../actions/usuarios.actions";
import { toast } from "react-toastify";

const CompartilhamentoCalculadoraDialogConnected = () => {
  const dispatch = useDispatch();
  const { show, data } = useSelector(getDialogCompartilhamento);

  const handleClose = useCallback(() => {
    dispatch(actions.exibirDialogCompartilhamento(false, null));
  }, [dispatch]);

  const handleCopyText = async (data) => {
    await navigator.clipboard.writeText(data).then(() => {
      toast.success("Link copiado para a área de transferência!", {autoClose: 1000});
    });
  };

  useEffect(() => {
    if (show) {
      handleCopyText(window.location.origin + "/externo/" + data);
    }
  }, [show])

  return (
    <CompartilhamentoCalculadoraDialog
      open={show}
      data={data}
      handleClose={handleClose}
      handleCopyText={handleCopyText}
    />
  );
};

export default CompartilhamentoCalculadoraDialogConnected;